<template>
  <div>
    <div class="main-slide-image_overlay overflow-hidden">
      <div class="main-slide-image"
           :class="class_list">
        <img class="main-slide-image_img"
             :src="img_src" alt="main slide">
        <img v-if="lazy_img.page_loaded"
             @load="lazy_img.show = true"
             :class="{img_loaded: lazy_img.show}"
             class="main-slide-image_img_lazy"
             :src="lazy_img_src"
             alt="main slide lazy">
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {ssr_window} from "../../helpers/ssr";

export default {
  name: "MainSlideImageSlot",
  props: {
    img_src: {
      type: String,
      default: '',
    },
    lazy_img_src: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters([
      'getIsMobile',
    ]),
    get_blur_img() {
      return this.lazy_img_src && !this.lazy_img.show;
    },
    class_list() {
      return {
        blurred: this.get_blur_img,
      }
    }
  },
  data() {
    return {
      lazy_img: {
        page_loaded: false,
        show: false
      },
    }
  },
  mounted() {
    ssr_window.addEventListener('load', this.pageLoaded)
  },
  methods: {
    pageLoaded() {
      if (this.lazy_img_src) {
        this.lazy_img.page_loaded = true
      }
    }
  }
}
</script>
